"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiCallDcInfos = exports.createOptions = void 0;
const ApiError_1 = require("./ApiError");
const checkStatus = (response) => {
    if (response.status >= 400) {
        const errMessage = 'Error getting data from the API';
        return response
            .json()
            .catch(() => response)
            .then((res) => {
            throw new ApiError_1.ApiError(errMessage, response.status, res);
        });
    }
    return Promise.resolve(response);
};
const createOptions = (options = {}) => {
    const defaultOptions = { method: 'GET' };
    const paramHeaders = options.headers || {};
    return {
        ...defaultOptions,
        ...options,
        headers: paramHeaders,
    };
};
exports.createOptions = createOptions;
const exec = (url, options = {}) => {
    return fetch(`${url}`, options)
        .then(checkStatus)
        .then((res) => {
        return res.json().catch(() => res);
    })
        .catch((err) => {
        throw err;
    });
};
const getMethod = (url) => () => exec(url, (0, exports.createOptions)({ method: 'GET', cache: 'no-store' }));
const apiCallDcInfos = () => () => {
    const url = 'https://dcinfos-cache.abtasty.com/v1/geoip';
    return {
        get: getMethod(url),
    };
};
exports.apiCallDcInfos = apiCallDcInfos;
//# sourceMappingURL=apiCallDcInfos.js.map